import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import { Typography } from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './HoverTooltip.scss';

const defaultProps = {
  title: 'title',
  messages: ['text line 1', 'text line 2', 'text line 3'],
  className: '',
  onClick: () => null,
};
const HtmlTooltip = styled((props) => {
  const { className, ...rest } = { ...defaultProps, ...filterUndefined(props) };
  return <Tooltip {...rest} classes={{ popper: className }} />;
})(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #dadde9',
  },
}));

/**
 * Tooltip dialog component.
 * Dialogs inform users about a task and can contain critical information, require decisions
 */
export default function HoverTooltip(props) {
  const { className, title, messages, onClick } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className={`hover-tooltip ${className}`}>
      <HtmlTooltip
        title={(
          <>
            <Typography><strong>{title}</strong></Typography>
            {messages.map((m, index) => (
              <p key={`tooltip-message-${index}`}>{m}</p>
            ))}
          </>
        )}
      >
        <HelpIcon className='hover-tooltip-icon' onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }} tabIndex={0} />
      </HtmlTooltip>
    </div>
  );
}
